<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14eNh82/tc-custom/9780226541723.jpg?1722571969697" alt="This image is the cover for the book Dangerous Earth"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dangerous Earth
      </h1>
      <p class="bookDescription body article font2">
        <b>“A fascinating and riveting read that really succeeds in bringing you right to the cutting edge of open questions in the earth sciences.” —Leon Vlieger, <i>Inquisitive Biologist</i></b><br/><br/>Today, we know more than ever before about the powerful forces that can cause catastrophe, but significant questions remain. Why can’t we better predict some natural disasters? What do scientists know about them already? What do they wish they knew? In <i>Dangerous Earth</i>, marine scientist and science communicator Ellen Prager explores the science of investigating volcanoes, earthquakes, tsunamis, hurricanes, landslides, rip currents, and—maybe the most perilous hazard of all—climate change. Each chapter considers a specific hazard, begins with a game-changing historical event (like the 1980 eruption of Mt. St. Helens or the landfall and impacts of Hurricane Harvey), and highlights what remains unknown about these dynamic phenomena. Along the way, we hear from scientists trying to read Earth’s warning signs, pass its messages along to the rest of us, and prevent catastrophic loss.<br/><br/>A sweeping tour of some of the most awesome forces on our planet—many tragic, yet nonetheless awe-inspiring—<i>Dangerous Earth</i> is an illuminating journey through the undiscovered, unresolved, and in some cases unimagined mysteries that continue to frustrate and fascinate the world’s leading scientists: the “wish-we-knews” that ignite both our curiosity and global change.<br/><br/><b>“If there is one main thread in Prager’s book it is that the main threat to humanity is climate change. The book is small, but it contains a wealth of information.” —Lars Backstrom, <i>Geoscientist</i></b><br/><br/><b>“Prager . . . delves into the mysteries of our planet’s hazards and why they continue to perplex the world’s scientists.” —Katie Aberbach, <i>Wesleyan</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellen Prager
      </h2>
      
      <p class="authorDescription body article"><B>Ellen Prager</B> is a marine scientist and author, widely recognized for her expertise and ability to make science entertaining and understandable for people of all ages. She was formerly the chief scientist at the world’s only undersea research station, Aquarius Reef Base in the Florida Keys, and assistant dean at the University of Miami’s Rosenstiel School of Marine and Atmospheric Sciences. Currently, she is a freelance writer, consultant, and science advisor to Celebrity Cruises in the Galapagos Islands. Among her numerous works of popular science writing is <I>Sex, Drugs, and Sea Slime: The Oceans’ Oddest Creatures and Why They Matter</I>, also published by the University of Chicago Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b97995ec